import React from 'react'

import PropTypes from 'prop-types'
import classNames from 'classnames'
import _ from 'lodash'

import Button from './Button'

export default class Form extends React.Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onSecondarySubmit: PropTypes.func,
    submittingToServer: PropTypes.bool,
    btnDisabled: PropTypes.bool,
    className: PropTypes.string,
    secondBtnLoading: PropTypes.bool,
    secondBtnDisabled: PropTypes.bool
  }

  static defaultProps = {
    submittingToServer: false,
    submitBtnName: 'Submit',
    secondBtnLoading: false,
    btnDisabled: false,
    secondBtnDisabled: false
  }

  state = {
    revalidate: false
  }

  componentWillMount() {
    const { children } = this.props

    const state = _.cloneDeep(this.state)

    React.Children.forEach(children, child => {
      if (child && 'props' in child) {
        state[child.props.id + 'Valid'] = true
      }
    })

    state.initial = true

    this.setState(state)
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.revalidate && !this.state.revalidate) {
      if (!this.state.initial && this.isValid()) {
        this.props.onSubmit(this.getValues())
      }
    }
  }

  formValid = (fieldId, valid) => {
    this.setState({
      revalidate: false,
      initial: false,
      [`${fieldId}Valid`]: valid
    })
  }

  handleFieldChange = (fieldId, value) => {
    this.setState({
      [fieldId]: value,
      isInvalid: false
    })
  }

  /**
   * Since field is removed it is needed to remove its state and validation status
   * @param {string} fieldId   field's input name (id)
   */
  handleFieldDelete = fieldId => {
    this.setState({
      [fieldId]: undefined,
      [`${fieldId}Valid`]: true
    })
  }

  handleSubmit = () => {
    this.setState({
      revalidate: true
    })
  }

  isValid() {
    let invalidFound

    const validFields = _.pickBy(this.state, (value, key) => {
      if (!invalidFound && key.indexOf('Valid') !== -1 && !value) {
        invalidFound = true

        const ref = key.slice(0, -5)
        const elToScroll = document.getElementById(ref)

        if (elToScroll && elToScroll.focus) {
          const top = elToScroll.offsetTop

          window.scrollTo(0, top)

          elToScroll.focus()
        }

        this.setState({
          isInvalid: true
        })
      }

      return key.indexOf('Valid') !== -1
    })

    const validFieldValues = _.values(validFields)

    return validFieldValues.length && _.every(validFieldValues)
  }

  getValues() {
    return _.pickBy(this.state, (value, key) => {
      return key.indexOf('Valid') === -1 && key !== 'revalidate' && key !== 'initial' && key !== '[object Object]'
    })
  }

  recursiveCloneChildren(children) {
    return React.Children.map(children, child => {
      let childProps = {}

      if (React.isValidElement(child) && typeof child.type === 'function') {
        childProps = {
          formValid: this.formValid,
          onChange: this.handleFieldChange,
          onDelete: this.handleFieldDelete,
          revalidate: this.state.revalidate
        }
      }

      if (child && child.props) {
        childProps.children = this.recursiveCloneChildren(child.props.children)

        return React.cloneElement(child, childProps)
      }

      return child
    })
  }

  render() {
    const {
      submittingToServer,
      submitBtnName,
      submitBtnClassname,
      btnDisabled,
      className,
      secondBtnName,
      secondBtnLoading,
      secondBtnDisabled,
      secondBtnClassname,
      onSecondarySubmit,
      thirdBtnName,
      thirdBtnLoading,
      thirdBtnClassname,
      onThirdSubmit,
      thirdBtnDisabled
    } = this.props

    const childrenWithProps = this.recursiveCloneChildren(this.props.children)

    const formClass = classNames({
      [className]: !!className
    })

    return (
      <div className={formClass}>
        {childrenWithProps}
        <div className="form-btn-row">
          <Button
            name={submitBtnName}
            className={submitBtnClassname}
            onSubmit={this.handleSubmit}
            loading={submittingToServer}
            loadingText="Saving"
            disabled={btnDisabled}
          />
          {secondBtnName ? (
            <Button
              name={secondBtnName}
              loading={secondBtnLoading}
              loadingText="Saving"
              className={secondBtnClassname}
              onSubmit={onSecondarySubmit}
              disabled={secondBtnDisabled}
            />
          ) : null}
          {thirdBtnName ? (
            <Button
              name={thirdBtnName}
              loading={thirdBtnLoading}
              loadingText="Saving"
              className={thirdBtnClassname}
              onSubmit={onThirdSubmit}
              disabled={thirdBtnDisabled}
            />
          ) : null}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/components/UI/Form.jsx